export default __webpack_public_path__ + "static/media/bubble_1_left.4ece52e8.png";